import { useGame } from "~/app";
import { TurnPhase } from "~/business";
import {
  XButton,
  XIntrigueCard,
  XPackBy,
  XPlayerIcon,
  XTypography,
} from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes } from "~/jsx/theme";
import { XDesignModal } from "../design/XDesignModal";

export const XCombatModal = () => {
  const { game } = useGame();
  const { onPassCombatIntrigue, onIntrigue } = useActions();
  const { turnPhase, currentBattleCard, fightingPlayers, combatPodium } = game;
  const viewingPlayer = useViewingPlayerOpt();
  const isCombatPhase =
    turnPhase === TurnPhase.CombatStart || turnPhase === TurnPhase.CombatEnd;
  const isFighting =
    viewingPlayer &&
    fightingPlayers.map(({ id }) => id).includes(viewingPlayer.id);
  const { intrigueCards } = viewingPlayer ?? {};
  const hasIntrigueCards = Boolean(intrigueCards?.length);

  const visible = isCombatPhase && isFighting && hasIntrigueCards;

  if (!fightingPlayers.length || !visible) {
    return null;
  }

  return (
    <XDesignModal
      name={ModalNames.combat}
      visible={visible}
      canHide={true}
      title="Combat"
    >
      {turnPhase === TurnPhase.CombatEnd && (
        <div style={{ display: "flex", alignItems: "center" }}>
          {(combatPodium?.[0]?.group ?? []).map((player, index) => (
            <div
              key={player.id}
              style={{ display: "flex", alignItems: "center" }}
            >
              {index > 0 && <XTypography>&nbsp;and&nbsp;</XTypography>}
              <XPlayerIcon width={32} playerId={player.id} />
              <XTypography>{player.name}</XTypography>
            </div>
          ))}
          <XTypography> &nbsp; won the conflict</XTypography>
        </div>
      )}
      {((turnPhase === TurnPhase.CombatStart && isFighting) ||
        (turnPhase === TurnPhase.CombatEnd &&
          (combatPodium?.[0]?.group ?? []).includes(viewingPlayer))) && (
        <div>
          <XTypography style={{ marginTop: 24, marginBottom: 12 }}>
            Do you want to play an intrigue card?
          </XTypography>
          <XButton
            onClick={onPassCombatIntrigue}
            style={{ display: "inline-block", marginBottom: 12 }}
          >
            Pass
          </XButton>
          <XPackBy packSize={5} gap={5}>
            {(intrigueCards?.pile ?? []).map((intrigueCard) => {
              const isPlayable = !game.validatePlayIntrigue(
                viewingPlayer.id,
                intrigueCard.id
              );
              return (
                <XIntrigueCard
                  key={intrigueCard.id}
                  onClick={
                    isPlayable ? () => onIntrigue(intrigueCard) : undefined
                  }
                  card={intrigueCard}
                  width={Sizes.intrigueCard.width}
                />
              );
            })}
          </XPackBy>
        </div>
      )}
    </XDesignModal>
  );
};
